import { Client } from "@/Common/Api/Client";
import { Server } from "@/Common/Operations/operations.server";
import { GrowthChartsCacheData } from "../Models/GrowthCharts/GrowthChartsCacheData";
import { LoadGrowthCurvesCacheResponse } from "../Models/GrowthCharts/LoadGrowthCurvesCacheResponse";

class GrowthChartApiClient {
    public static async getGrowthChartsCacheData(): Promise<GrowthChartsCacheData> {
        if (cacheStore.GrowthChartDataModels)
            return cacheStore.GrowthChartDataModels;

        const response = await Client.postAsync<LoadGrowthCurvesCacheResponse>(Server.Myle_Patient_LoadGrowthCurvesCache, {});

        if (response.data)
            cacheStore.GrowthChartDataModels = response.data;

        return response.data as GrowthChartsCacheData;
    }
}

export { GrowthChartApiClient };
